import { createContext } from 'react';
import { noop } from 'src/utils/noop';
import { ZHLExperienceDestructiveOperationAction } from 'src/services/graphql/generated/graphql';

export type DestructiveOperationActionHandlerConfiguration = {
    /**
     * Callback for when the user cancels the destructive action.
     *
     * This will be called _after_ the confirmation dialog has closed.
     */
    onCancel?: () => void;
    /**
     * Callback for when the user confirms the destructive action.
     *
     * The return value of this callback will be ignored, so this is for analytics only. the provider
     * will handle the actual mutation
     */
    onConfirm?: () => void;
    /**
     * After the mutation is complete, the hook result from the mutation will be passed to this callback
     */
    afterMutation?: <T = unknown>(mutationResult?: T) => void;
    /**
     * An optional payload to pass to the mutation
     */
    payload?: object;
};

export type DestructiveOperationHandler = (
    action: ZHLExperienceDestructiveOperationAction,
    config?: DestructiveOperationActionHandlerConfiguration
) => void;

export const DestructiveOperationActionHandlerContext = createContext<{
    handleDestructiveOperation: DestructiveOperationHandler;
}>({
    handleDestructiveOperation: noop,
});
